import template from './defa-weather.vue.html'

export const WeatherComponent = {
	template,
	props: {
		period: {
			type: Object
		},
		weather: {
			type: Object
		},
		iconType: {
			type: String,
			default: 'svg'
		},
		iconPath: {
			type: String,
			default: '/assets/vendor/yr'
		}
	},
	computed: {
		imgSrc() {
			return `${this.iconPath}/${this.weather.icon}.${this.iconType}`
		}
	}
};

export const WeatherComponentPlugin = {
	install(Vue, options) {
		Vue.component('defa-weather', WeatherComponent)
	}
};